var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.9,
    height: 40.913,
    viewBox: "0 0 40.9 40.913",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.529 -280.594)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.529 280.594)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-105.384,117.174c9.122,9.122,18.948,7.892,26.19,2.24a2.361,2.361,0,0,0,0-3.676l-6.246-4.054c-1.208-.784-2.658-1.018-3.676,0-1.365,1.374-.92,2.722-2.25,4.128-1.6,1.6-5.4-.084-9-3.659-3.869-3.854-5.566-7.823-4.025-9.363,1.108-1.181,2.991-1.5,4.136-2.648,1.018-1.018.741-2.441,0-3.676l-4.045-6.734a2.344,2.344,0,0,0-3.676,0C-114.8,99.64-113.171,109.387-105.384,117.174Z",
    transform: "translate(112.273 -82.928)",
    fill: "#dad4d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-93.572,86.547a12.636,12.636,0,0,0-12.636,12.636,12.645,12.645,0,0,0,2.176,7.069l-1.817,6.782,7.738-2.073a12.636,12.636,0,0,0,4.539.857A12.636,12.636,0,0,0-80.936,99.183,12.636,12.636,0,0,0-93.572,86.547Z",
    transform: "translate(121.837 -86.547)",
    fill: "#eae8e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-109.5,98.033a1.363,1.363,0,0,0-1.31.948,27.944,27.944,0,0,0,3.13,3.7c7.8,7.8,16.132,8.025,22.908,4.39a1.378,1.378,0,0,0-1.947-1.554c-4.877,2.438-9.5,1.786-13.718-.221-4.013-1.911-8-6.738-8-6.738a1.363,1.363,0,0,0-1.061-.529Z",
    transform: "translate(114.574 -68.439)",
    fill: "#a29292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-102.3,88.975h9.425A1.47,1.47,0,0,1-91.4,90.448v8.944a1.47,1.47,0,0,1-1.473,1.473H-102.3a1.47,1.47,0,0,1-1.473-1.473V90.448A1.47,1.47,0,0,1-102.3,88.975Z",
    transform: "translate(125.68 -82.721)",
    fill: "#ffca3a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-102.009,88.975v2.652a.691.691,0,0,0,.693.692H-99.4a.691.691,0,0,0,.693-.692V88.975Z",
    transform: "translate(128.455 -82.721)",
    fill: "#dad4d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-101.561,92.694A1.364,1.364,0,0,0-102.543,95h8.34a1.47,1.47,0,0,0,1.474-1.473v-.835Z",
    transform: "translate(127.011 -76.857)",
    fill: "#ff9700"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.30137c017d5b8f1bdbd1f704a8c0719d.svg";
export { ForwardRef as ReactComponent };